 
 
 

import React from "react";

import { Box, Tab, Tabs } from "@mui/material";
import {
  ListAltOutlined,
  Summarize,
} from "@mui/icons-material";
import { a11yProps } from "../../../../../../components/Tabs/utils";
import { TabPanel } from "../../../../../../components/Tabs/TabPanel";
import { PageContainer } from "../../../../../../components/container/PageContainer";
import { CommAutoPolicyNotesList } from "./CommAutoPolicyNotesList";
import { ActivityEmailConversationLogs } from "../../../../../../components/Activity/ActivityEmailConversationLogs";
import { useOutletContext } from "react-router-dom";
import { MODULE_NAMES } from "../../../../../../constants/enums";

export const CommAutoActivitiesTabs: React.FC = () => {
    const data = useOutletContext() as any;
  const customerId = data[0];
  const customerPolicyId = data[1];

  const moduleInformation = {
    moduleId: customerPolicyId,
    moduleName: MODULE_NAMES.COMMERCIAL_AUTO,
    subModuleName: MODULE_NAMES.COMMERCIAL_AUTO,
    refColumnName: "customer_policy_id",
  };

  const [tab, setTab] = React.useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, value: any) => {
    setTab(value);
  };

  return (
    <PageContainer
      title="Activities"
      description="this is innerpage"
    >
      {/* <Breadcrumb title="View Statement" items={BCrumb} /> */}

      <Box display={"flex"} justifyContent={"center"}>
        <Tabs value={tab} onChange={handleChangeTab} sx={{ mb: 1, mt: 3 }}>
          <Tab
            icon={<ListAltOutlined />}
            iconPosition="start"
            label="Policy Notes"
            sx={{ fontSize: "1.1rem", fontWeight: 600, minWidth: 200 }}
            {...a11yProps(0)}
          />
          <Tab
            icon={<Summarize />}
            iconPosition="start"
            label="Email Conversations"
            sx={{ fontSize: "1.1rem", fontWeight: 600, minWidth: 200 }}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>

      {/* <Divider /> */}
       <TabPanel value={tab} index={0}>
        <CommAutoPolicyNotesList
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          moduleInformation={moduleInformation}
        />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <ActivityEmailConversationLogs moduleInformation={moduleInformation} isEmailButton={true}/>
      </TabPanel>
     
    </PageContainer>
  );
};
